export default __webpack_public_path__ + "static/media/signal-high.358f5490.svg";